import React, { useCallback, useEffect, useState } from 'react'
import Wrapper from '../../components/Wrapper'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { historyHeader, input, menu, sip } from '../../translate'
import { Box, Typography, Grid, Card, CardContent, ToggleButton, ToggleButtonGroup, Paper, TablePagination, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Chip, Avatar } from '@mui/material'
import ViewListIcon from '@mui/icons-material/ViewList'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from 'react-router-dom'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { blockedDeleteLocal, blockedRequest } from '../../store/actions/blocked'
import AddBlocked from '../../components/AddBlocked'
import Utils from '../../Utils'
import qs from 'query-string'
import Api from '../../Api'
import { Tooltip } from 'react-tooltip'
import Cookies from 'js-cookie'
import AssignedSearch from '../../components/new_component/AssignedSearch'
import { cardStyles, employeeTableStyles, activitiesStyles } from '../../helpers/style'

const { REACT_APP_SERVER } = process.env
const color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

export default function BlockedNumbers() {
  const blockedData = useSelector(state => state.blocked.blockedData) || []
  const count = useSelector(state => state.blocked.count)
  const page = useSelector(state => state.blocked.page)
  const [create, setCreate] = useState(false)
  const [viewMode, setViewMode] = useState('table')
  const [searchQuery, setSearchQuery] = useState('')
  const [cardPage, setCardPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(9)
  const [tablePage, setTablePage] = useState(0)
  const [tableRowsPerPage, setTableRowsPerPage] = useState(10)
  const location = useLocation()
  const navigate = useNavigate()
  const query = qs.parse(location.search, { arrayFormat: 'comma' })
  const dispatch = useDispatch()
  const langIndex = +localStorage.getItem('atsLang') || 1

  useEffect(() => {
    (async () => {
      await dispatch(blockedRequest(Cookies.get('blocked') || query.limit || 10, query.page || 1, query.search || ''))
    })()
  }, [location.search, dispatch])

  useEffect(() => {
    if (query.search) {
      setSearchQuery(query.search)
    }
  }, [query.search])

  const handleDelete = useCallback(async (id) => {
    try {
      const text = langIndex === 1 ? 'Are you sure you want to delete?' :
        langIndex === 2 ? 'Вы уверены, что хотите удалить?' :
          'Վստա՞հ եք, որ ցանկանում եք ջնջել'

      if (confirm(text) === true) {
        await dispatch(blockedDeleteLocal(id))
        try {
          await Api.deleteBlocked(id)
        } catch (e) {
          console.log(e)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }, [dispatch, langIndex])

  const handleSearch = useCallback((value) => {
    setSearchQuery(value)
    query.search = value
    query.page = '1'
    navigate(`?${qs.stringify(query, {
      arrayFormat: 'comma',
      skipEmptyString: true,
    })}`)
  }, [navigate, query])

  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode)
    }
  }

  const handleChangePage = useCallback((page) => {
    query.page = page + 1
    navigate(`?${qs.stringify(query, {
      arrayFormat: 'comma',
      skipEmptyString: true,
    })}`)
  }, [location.search, navigate, query])

  const handleLimit = useCallback((page) => {
    query.limit = page
    query.page = '1'
    Cookies.set('blocked', page, { expires: 30 })
    navigate(`?${qs.stringify(query, {
      arrayFormat: 'comma',
      skipEmptyString: true,
    })}`)
  }, [location.search, navigate, query])

  const handleCardChangePage = (event, newPage) => {
    setCardPage(newPage)
  }

  const handleCardChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setCardPage(0)
  }

  const handleTableChangePage = (event, newPage) => {
    setTablePage(newPage)
  }

  const handleTableChangeRowsPerPage = (event) => {
    setTableRowsPerPage(parseInt(event.target.value, 10))
    setTablePage(0)
  }

  const filteredData = searchQuery
    ? blockedData.filter(item =>
        (item.phone && item.phone.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.notes && item.notes.toLowerCase().includes(searchQuery.toLowerCase()))
      )
    : blockedData

  const paginatedCards = rowsPerPage > 0
    ? filteredData.slice(cardPage * rowsPerPage, cardPage * rowsPerPage + rowsPerPage)
    : filteredData

  const paginatedTable = tableRowsPerPage > 0
    ? filteredData.slice(tablePage * tableRowsPerPage, tablePage * tableRowsPerPage + tableRowsPerPage)
    : filteredData

  const blockedTitleArr = [historyHeader.phone1[langIndex], sip.note[langIndex]]
  const blockedDescArr = filteredData.map(s => ({ phone: s.phone, notes: s.notes || '-' }))

  return (
    <>
      <Helmet>
        <title>
          {menu.block[langIndex]}
        </title>
      </Helmet>
      <Wrapper>
        {viewMode === 'table' ? (
          <div className="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
              <Box sx={employeeTableStyles.headerBox}>
                <Box sx={{ ...employeeTableStyles.headerTitleBox, width: '100%' }}>
                  <Typography sx={employeeTableStyles.title} variant="h5" component="h1">
                    {menu.block[langIndex]}
                  </Typography>
                </Box>
              </Box>
              <Box sx={employeeTableStyles.searchSortContainer}>
                <Box sx={employeeTableStyles.searchBox}>
                  <AssignedSearch
                    value={searchQuery}
                    onChange={handleSearch}
                    onAdd={() => setCreate(true)}
                    placeholder={input.search[langIndex]}
                    showAdd={true}
                  />
                </Box>
              </Box>

              {paginatedTable.length ? (
                <>
                  <Box sx={activitiesStyles.activitiesContainer}>
                    {paginatedTable.map((s) => (
                      <Card key={s.id} sx={{ ...activitiesStyles.activityCard, height: 100, minHeight: 100, maxHeight: 100 }}>
                        <CardContent sx={activitiesStyles.cardContent}>
                          <Box sx={{...activitiesStyles.cardContentBox, alignItems: 'center'}}>
                            <Avatar sx={activitiesStyles.getActivityAvatar(true)}>
                              {(s.phone || s.notes || '?')[0].toString().toUpperCase()}
                            </Avatar>
                            <Box sx={{ ...activitiesStyles.activityContentBox, flex: 1, minWidth: 0 }}>
                              <Typography variant="h6" sx={activitiesStyles.activityTitle} component="span">
                                {s.phone}
                                {(s.notes != null && s.notes !== '') && (
                                  <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 0.75, fontWeight: 400, lineHeight: '24px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280, display: 'inline-block', verticalAlign: 'bottom' }} data-tooltip-content={s.notes} data-tooltip-id={s.id.toString()}>
                                    — {s.notes}
                                  </Typography>
                                )}
                              </Typography>
                            </Box>
                            <Box sx={{...employeeTableStyles.actionsContainer, height: "50px", minHeight: "50px"}}>
                              <IconButton size="small" onClick={() => handleDelete(s.id)} sx={employeeTableStyles.deleteIconButton} aria-label="Delete">
                                <FontAwesomeIcon icon={faTrashCan} />
                              </IconButton>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    ))}
                  </Box>
                  {paginatedTable.map(s => (
                    <Tooltip key={`tooltip-${s.id}`} className="tooltip" id={s.id.toString()} />
                  ))}
                  <Box sx={employeeTableStyles.footerBox}>
                    <Box sx={employeeTableStyles.footerLinksBox}>
                      <Chip label="EXCEL" variant="outlined" size="small" onClick={() => Utils.dataToExel(blockedTitleArr, blockedDescArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: '#7ebc0a', color: '#fff', borderColor: '#7ebc0a' } }} />
                      <Chip label="CSV" variant="outlined" size="small" onClick={() => Utils.dataToExel(blockedTitleArr, blockedDescArr)} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: '#7ebc0a', color: '#fff', borderColor: '#7ebc0a' } }} />
                      <Chip label="PRINT" variant="outlined" size="small" onClick={() => window.print()} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: '#7ebc0a', color: '#fff', borderColor: '#7ebc0a' } }} />
                      <Chip label="COPY" variant="outlined" size="small" onClick={() => Utils.copy(() => {})} sx={{ cursor: 'pointer', borderRadius: '7px', padding: '4px', fontSize: 11, '& .MuiChip-label': { fontSize: 11 }, '&:hover': { backgroundColor: '#7ebc0a', color: '#fff', borderColor: '#7ebc0a' } }} />
                    </Box>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100, { label: 'All', value: -1 }]}
                      component="div"
                      count={filteredData.length}
                      rowsPerPage={tableRowsPerPage}
                      page={tablePage}
                      onPageChange={handleTableChangePage}
                      onRowsPerPageChange={handleTableChangeRowsPerPage}
                      labelRowsPerPage={input.rowsPerPage[langIndex]}
                    />
                  </Box>
                </>
              ) : (
                <Box sx={employeeTableStyles.emptyStateBox}>
                  <Typography variant="body1" color="text.secondary">
                    {searchQuery ? (langIndex === 1 ? 'No blocked numbers found matching your search' : langIndex === 2 ? 'По вашему запросу ничего не найдено' : 'Որոնումով արգելափակված համարներ չեն գտնվել') : (langIndex === 1 ? 'No blocked numbers found' : langIndex === 2 ? 'Нет заблокированных номеров' : 'Արգելափակված համարներ չկան')}
                  </Typography>
                </Box>
              )}
            </Paper>
          </div>
        ) : (
          <div className="tableParent">
            <Paper sx={{ p: 3, boxShadow: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography sx={{ fontWeight: 700, m: 0 }} variant="h5" component="h1">
                  {menu.block[langIndex]}
                </Typography>
                <ToggleButtonGroup
                  value={viewMode}
                  exclusive
                  onChange={handleViewModeChange}
                  aria-label="view mode"
                  size="small"
                >
                  <ToggleButton value="table" aria-label="table view">
                    <ViewListIcon />
                  </ToggleButton>
                  <ToggleButton value="card" aria-label="card view">
                    <ViewModuleIcon />
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              <Box sx={{ mb: 3 }}>
                <AssignedSearch
                  value={searchQuery}
                  onChange={handleSearch}
                  onAdd={() => setCreate(true)}
                  placeholder={input.search[langIndex]}
                  showAdd={true}
                />
              </Box>
              <Grid container spacing={3}>
                {paginatedCards.length > 0 ? (
                  paginatedCards.map(s => (
                    <Grid item xs={12} sm={6} md={4} key={s.id} sx={{ display: 'flex' }}>
                      <Card sx={cardStyles.card}>
                        <CardContent sx={cardStyles.cardContent}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                            <Typography variant="h6" component="div" sx={{ fontSize: '1.35rem' }}>
                              {s.phone}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <span
                                onClick={() => handleDelete(s.id)}
                                className="delete"
                                style={{ cursor: 'pointer', margin: '0 5px', fontSize: '16px' }}
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </span>
                            </Box>
                          </Box>
                          <hr/>
                          <Typography variant="body2" sx={{ mb: '6px', color: 'rgb(0 0 0 / 70%)' }}>
                            <strong>{sip.note[langIndex]}:</strong> {s.notes || '-'}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                      <Typography color="text.secondary">
                        {searchQuery ? 'No blocked numbers found matching your search' : 'No blocked numbers found'}
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
              {viewMode === 'card' && (
                <TablePagination
                  component="div"
                  count={filteredData.length}
                  page={cardPage}
                  onPageChange={handleCardChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleCardChangeRowsPerPage}
                  rowsPerPageOptions={[9, 18, 27, 36]}
                  sx={{
                    borderTop: '1px solid #e0e0e0',
                    mt: 2,
                    '& .MuiTablePagination-toolbar': {
                      px: 0,
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                      m: 0,
                    },
                  }}
                />
              )}
            </Paper>
          </div>
        )}
        {create ? <AddBlocked open={create} edit={false} setOpen={setCreate} /> : null}
      </Wrapper>
    </>
  )
}
